<template>
  <div class="add-salary-form">
    <div class="add-salary-form-container" v-loading="loading">
      <div class="title">新增工资表</div>
      <div class="add-salary-content">
        <el-steps :active="active" align-center>
          <el-step title="选择模板"></el-step>
          <el-step title="工资制表"></el-step>
          <el-step title="基本设置"></el-step>
        </el-steps>

        <!-- 选择模板 -->
        <div v-if="active == 1" class="step-content">
          <div class="select-tmp">
            <p class="select-tmp-title">选择模板:</p>
            <div>
              <el-select
                v-model="salaryTmpId"
                placeholder="请选择模板"
                class="gray white w340"
                clearable
                @change="changeSelectTmpId"
              >
                <el-option
                  v-for="item in salaryTmpList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="download" @click="download">下载导入模板</div>
          </div>
          <div class="explain">
            <p class="explain-title">说明：</p>
            <ul>
              <li>请先选择模板再开始下一步制表</li>
              <li>如需要导入表格完成工资制表，则点击”下载导入模板“获取模板</li>
              <li>请确保按模板格式填写，完成后在工资制表中完成上传</li>
              <li>在制表时发现找不到用户，请先完成添加</li>
            </ul>
          </div>
        </div>

        <!-- 工资制表 -->
        <div v-if="active == 2" class="step2-content">
          <div class="right">
            <div class="table">
              <el-table
                  :data="categroyTableList"
                  style="width: 100%"
                  height="543"
                  class="salary-table"
                  @selection-change="handleSelectionChange"
                >
                <el-table-column width="220" fixed>
                  <template slot="header">
                    <div class="item-title">
                      <div class="add-staff-title">
                        <span>已添加人员（{{ tableData.length }}）</span>
                        <el-button type="text" class="btn-text" @click="addStaff"
                          >添加</el-button
                        >
                      </div>
                    </div>
                  </template>

                  <el-table-column type="selection" width="34"></el-table-column>
                  <el-table-column label="姓名">
                    <template slot-scope="scope">
                      <div :class="{ activeColor: !scope.row.userObj.id }">
                        {{ scope.row.userObj.name }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="110">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        class="btn-text"
                        @click="removeUser(scope.$index, scope.row.userObj.id)"
                        >移除</el-button
                      >
                      <el-button
                        v-if="!scope.row.userObj.id || !scope.row.userObj.deptId"
                        type="text"
                        class="btn-text"
                        @click="openMatching(scope.$index)"
                        >匹配</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column
                  v-for="(item, index) in categroyTitleList"
                  :key="index"
                >
                  <template slot="header">
                    <div class="item-title">
                      <el-tooltip
                        :disabled="isShowTooltip"
                        :content="item.categoryName"
                        :open-delay="500"
                        effect="dark"
                        placement="top-end"
                      >
                        <div class="item-name"
                        @mouseenter="showTips($event, item, item.categoryName)"
                        >
                          <span
                            :ref="`${item.categoryName}${index}`"
                          >{{ item.categoryName }}</span>
                        </div>
                      </el-tooltip>
                    </div>
                  </template>
                  <el-table-column v-for="(v, idx) in item.itemList" :key="`${idx}+${new Date().getTime()}`">
                    <template slot="header">
                      <div class="item-title">
                        <el-tooltip
                          :disabled="isShowTooltip"
                          :content="v.itemName"
                          effect="dark"
                          placement="top-end"
                        >
                          <div class="item-name"
                          @mouseenter="showTips($event, v, v.itemName)"
                          >
                            <span
                              :ref="`${v.itemName}${index}${idx}`"
                            >{{ v.itemName }}</span>
                          </div>
                        </el-tooltip>
                        <i
                          class="el-icon-edit"
                          @click="openBatchModification(v, item.categoryKey)"
                        ></i>
                      </div>
                    </template>
                    <template slot-scope="scope">
                      <div v-if="scope.row[item.categoryKey]">
                        <div
                          v-if="
                            scope.row[item.categoryKey]
                              ? scope.row[item.categoryKey][idx].type ==
                                'Customize'
                              : ''
                          "
                        >
                          <el-input
                            v-if="scope.row[item.categoryKey]"
                            class="white"
                            :class="{
                              activeBorder:
                                !scope.row[item.categoryKey][idx].isHight,
                            }"
                            @change="
                              changeLabelDetials(
                                scope.row[item.categoryKey][idx].itemValue,
                                scope.row,
                                item.categoryKey,
                                idx,
                                v.contentId
                              )
                            "
                            @input="
                              inputAmount(
                                  scope.row[item.categoryKey][idx].itemValue,
                                  scope.row,
                                  item.categoryKey,
                                  idx
                              )"
                            v-model="scope.row[item.categoryKey][idx].itemValue"
                          ></el-input>
                        </div>
                        <div v-else>
                          <el-select
                            v-if="scope.row[item.categoryKey]"
                            v-model="scope.row[item.categoryKey][idx].itemValue"
                            class="gray white"
                            :class="{
                              activeBorder:
                                !scope.row[item.categoryKey][idx].isHight,
                            }"
                            @change="
                              changeDetails(
                                v.contentList,
                                scope.row[item.categoryKey][idx].itemValue,
                                scope.row,
                                item.categoryKey,
                                idx
                              )
                            "
                          >
                            <el-option
                              v-for="(item, index) in v.contentList"
                              :key="index"
                              :label="item.content"
                              :value="item.contentId"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="del-select-container">
            <el-button
              v-if="selectDelStaff.length > 0"
              type="text"
              class="btn-blue del-select"
              @click="removeAllUser"
              >移除选中人员</el-button
            >
          </div>
        </div>

        <!-- 基本设置 -->
        <div v-if="active == 3" class="step3-content">
          <div class="step3-left">
            <el-form
              :model="ruleform"
              ref="ruleform"
              :rules="rules"
              class="demo-form"
            >
              <el-form-item label="所属月份:" prop="month">
                <el-date-picker
                  v-model="ruleform.month"
                  value-format="yyyy-MM"
                  type="month"
                  class="gray white w240"
                  placeholder="选择月"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="标题:" prop="title">
                <el-input
                  class="gray white w240"
                  v-model="ruleform.title"
                ></el-input>
              </el-form-item>
              <el-form-item label="温馨提示:">
                <el-switch v-model="ruleform.promptFlag"></el-switch>
              </el-form-item>
              <div class="salary-title">工资条属于敏感信息，请注意保密</div>
              <el-form-item label="备注:" class="remark">
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="ruleform.remark"
                  maxlength="50"
                  show-word-limit
                  resize="none"
                  rows="3"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="step3-right">
            <div class="pay-title">
              <div class="pay-text">
                {{ ruleform.title }}
              </div>
              <div class="preview">预览</div>
            </div>
            <div class="pay-info">
              <p class="pay-slip-name">{{ name }}</p>
              <p class="pay-slip-amount">{{ salary }}</p>
              <p class="pay-slip-title">实发合计（元）</p>
            </div>
            <div v-if="ruleform.promptFlag" class="pay-slip-reminder">工资条属于敏感信息，请注意保密</div>
            <div class="step3-right-content">
              <div
                v-for="(item, index) in previewList"
                :key="index"
                class="preview-container"
              >
                <div class="category-title">{{ item.categoryName }}</div>
                <div
                  v-for="(v, idx) in item.list"
                  :key="idx"
                  class="preview-details"
                >
                  <div class="preview-details-name">
                    <p>{{ v.name }}</p>
                    <el-tooltip
                      effect="dark"
                      :content="v.content"
                      placement="right"
                    >
                      <img class="tooltip" src="../../../../assets/tooltip.png" />
                    </el-tooltip>
                  </div>
                  <div>{{ v.amount }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="foot">
        <upload-files
          class="export-tmp"
          v-if="active == 2"
          :btnText="btnText"
          :limit="limit"
          :isUploadTextCopy="false"
          :showFileList="false"
          :isBtnBlueText="true"
          :image="enclosure"
          :isFileStream="true"
          :fileArr="fileList"
          @uploadFile="cooperationAgreement"
        />

        <el-button v-if="active < 3" class="btn-blue" type="primary" @click="next"
          >下一步</el-button
        >
        <el-button
          v-if="active == 3"
          class="btn-border-text-blue"
          type="primary"
          :disabled="salaryFormId != ''"
          @click="save('ruleform')"
          >保存</el-button
        >
        <el-button
          v-if="active == 3"
          class="btn-blue"
          type="primary"
          :disabled="!salaryFormId"
          @click="launchApproval"
          >发起审批</el-button
        >
      </div>
    </div>

    <!-- 批量修改 -->
    <el-drawer
      :visible.sync="drawer"
      :size="400"
      :modal="false"
      :with-header="false"
      :wrapperClosable="false"
    >
      <div class="drawer-title">
        <i class="el-icon-close" @click="closeDrawer"></i>
        <div>
          <el-button type="text" class="btn-gray" @click="closeDrawer"
            >取消</el-button
          >
          <el-button type="text" class="btn-blue" @click="submitForm">
            保存
          </el-button>
        </div>
      </div>
      <div class="sub-title">批量修改</div>
      <el-form :model="form" ref="form" class="demo-ruleForm demo-form">
        <el-form-item label="细项名称">
          <el-input
            class="gray white"
            v-model="form.itemName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="解读内容">
          <el-input
            v-if="form.type == 'Customize'"
            class="gray white"
            v-model="form.content"
          ></el-input>
          <el-select
            v-else
            v-model="form.amount"
            class="gray white"
            clearable
            @change="changeLabel"
          >
            <el-option
              v-for="(item, index) in form.contentList"
              :key="index"
              :label="item.content"
              :value="item.contentId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="check-title">修改对象</div>
        <div>
          <el-checkbox-group v-model="checkList">
            <el-checkbox
              v-for="(item, index) in tableData"
              :key="index"
              :label="item.id"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </el-form>
    </el-drawer>

    <!-- 添加成员和匹配  -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="840px"
      :before-close="closeDialog"
    >
      <div class="stayDistribution">
        <div class="table-right">
          <p v-if="isAddPeople == 2" class="title">
            每名用户只能被选择一次，且已添加过的人员无法被选择
          </p>
          <tree
            :companyList="companyList"
            :departmentId="departmentId"
            :isSearch="isSearch"
            @selectTreeNodeList="selectDepartment"
          />
        </div>
        <div class="table table-left">
          <div class="search-table">
            <el-input
              class="gray white"
              @keyup.enter.native="initMember"
              v-model="searchStaff"
              placeholder="请输入成员"
            ></el-input>
          </div>
          <el-table
            :data="staffList"
            style="width: 100%"
            height="250"
            @selection-change="handleSelectionPeople"
          >
            <el-table-column
              v-if="isAddPeople == 1"
              type="selection"
              width="60"
              key="1"
            ></el-table-column>
            <el-table-column prop="name" label="姓名" key="2" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="assign-name">
                  <img class="matching-img" :src="scope.row.image" />
                  <span>{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="isAddPeople == 1"
              prop="phone"
              label="手机号"
              key="3"
            ></el-table-column>
            <el-table-column v-if="isAddPeople == 2" label="操作" key="4">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="btn-text"
                  @click="matching(scope.row)"
                  >匹配</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Salary from "@/models/salary.js";
import { config } from "@/common/js/config.js";
import uploadFiles from "@/components/upload-files.vue";
import { handleAmount, mapChild, mapId2, inputTwoDecimal, keepTwoDecimal } from "@/common/js/utils.js";
import Tree from "@/components/Tree.vue";
export default {
  components: {
    uploadFiles,
    Tree,
  },

  data() {
    return {
      loading: false,
      /* 是否是新增编辑; 1:新增；2：编辑 */
      isMod: '',
      active: 1,
      /* 模板id */
      salaryTmpId: "",
      /* 编辑时带来的工资表id */
      payrollId: '',
      /* 制表后的工资表id */
      salaryFormId: "",
      salaryTmpList: [],
      /* 已添加人员集合 */
      tableData: [],
      /* 选中删除的人员 */
      selectDelStaff: [],
      categroyTableList: [],
      categroyTitleList: [],
      enclosure: [],
      fileList: [],
      btnText: "导入模板",
      limit: 9999,
      drawer: false,
      /* 批量修改集合 */
      batchModification: [],
      form: {
        itemName: "",
        itemId: "",
        type: "",
        content: "",
        itemValue: "",
        amount: "",
        categoryKey: "",
        contentId: '',
        contentList: [],
      },
      /* 批量修改选中的人员 */
      checkList: [],
      title: "添加人员",
      dialogVisible: false,
      /* 是否是添加人员；1 是； 2：否 */
      isAddPeople: 1,
      isSearch: false,
      companyList: [],
      departmentId: 0,
      /* 三级部门id */
      threeDepetId: 0,
      staffList: [],
      searchStaff: "",
      /* 临时添加的人员 */
      temporarySelectPeople: [],
      /* 临时添加的细项 */
      temporaryAddDetails: [],
      /* 匹配下标 */
      matchIndex: "",
      /* 临时匹配对象 */
      temporaryMatchObj: null,

      ruleform: {
        month: "",
        title: "",
        remark: "",
        promptFlag: true,
      },
      rules: {
        month: [
          {
            required: true,
            message: "请选择月份",
            trigger: "change",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入工资标题",
            trigger: "blur",
          },
        ],
      },
      name: "",
      salary: "",
      /* 预览数据 */
      previewList: [],
      isShowTooltip: true,
      /* 1:编辑;2:复制 */
      type: ''
    };
  },

  created() {
    config();
    this.isMod = this.$route.query.isMod
    this.type = this.$route.query.type
    if (this.isMod == 2) {
      this.payrollId = this.$route.query.payrollId
      this.active = 2
      if (this.type == 1) {
        this.initModSalaryTypeList()
        this.initModSalaryInfo()
      } else if (this.type == 2) {
        this.salaryTmpId = this.$route.query.templateId
        this.initCopySalaryTypeList()
        this.initCopySalaryInfo()
      }
    }
    this.initTmpList();
    this.initDepartmentList();
  },

  methods: {
    /* 获取模板列表 */
    initTmpList() {
      Salary.getSalaryTmpList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            arr.push(obj);
          });
          this.salaryTmpList = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    changeSelectTmpId() {
      this.initSalaryTypeList();
    },

    /* 下载导入模板 */
    download() {
      let templateId = this.salaryTmpId;
      let data = {
        templateId,
      };
      Salary.downloadSalaryTmp(data).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },

    next() {
      if (!this.salaryTmpId && this.isMod == 1) {
        this.$message.error("请选择模板");
        return;
      }
      if (this.active == 2) {
        if (this.isMod == 1) this.initSalaryTypeList();
        if (this.isMod == 2) {
          if (this.type == 1) this.initModSalaryTypeList();
          if (this.type == 2) this.initCopySalaryTypeList();
        }
        let isHight = false;
        let isUserId = false;
        this.tableData.map((i) => {
          if (!i.id || !i.deptId) isUserId = true;
        });
        if (isUserId) {
          this.$message({
            type: "error",
            message: "请先匹配人员",
          });
          return;
        }
        this.categroyTitleList.map((i) => {
          this.categroyTableList.map((t) => {
            t[i.categoryKey].map((tt) => {
              if (!tt.isHight) isHight = true;
            });
          });
        });

        if (isHight) {
          this.$message({
            type: "error",
            message: "请选择标签细项值",
          });
          return;
        }
      }
      if (this.active < 3) this.active++;
      if (this.active == 3) {
        let firstObj = this.categroyTableList[0];
        let name = this.tableData.find((ele) => ele.id == firstObj.userId).name;
        this.name = `${name}, 工作辛苦了`;
        let arr = [];
        let salary = 0;
        this.categroyTitleList.map((i) => {
          let obj = {};
          obj.categoryName = i.categoryName;
          obj.list = [];
          firstObj[i.categoryKey].map((v) => {
            let obj2 = {};
            obj2.name = v.itemName;
            obj2.amount = v.itemValue;
            if (i.ruleType == 'Increment') salary += Number(v.itemValue);
            if (i.ruleType == 'Decrease') salary -= Number(v.itemValue);
            if (v.type == "Label") {
              // 标签设置---获取解读内容
              i.itemList.map((val) => {
                if (val.itemId == v.itemId) {
                  val.contentList.map(j => {
                    if (j.contentId == v.contentId) {
                      obj2.content = `${j.content}：${j.amount}元`;
                    }
                  })
                }
              });
            }
            if (v.type == "Customize") {
              // 自定义设置---获取解读内容
              i.itemList.map((val) => {
                if (val.itemId == v.itemId) {
                  obj2.content = val.content;
                }
              });
            }
            obj.list.push(obj2);
          });
          arr.push(obj);
        });
        this.salary = keepTwoDecimal(salary);
        this.previewList = arr;
      }
    },

    /* 获取上传模板 */
    cooperationAgreement(v) {
      this.enclosure = v;
      this.exportTmp();
    },

    /* 导入模板 */
    exportTmp() {
      let file = this.enclosure.length > 0 ? this.enclosure[0] : "";
      if (file === "") {
        this.$message.error("请选择上传模板");
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      if (this.isMod == 1) {
        this.addExportSalaryTmp(formData)
      } else {
        if (this.type == 2) {
          this.addExportSalaryTmp(formData)
        } else {
          this.modExportSalaryTmp(formData)
        }
      }
    },

    /* 新增导入模板 */
    addExportSalaryTmp(formData) {
      this.loading = true
      let salaryTmpId = this.salaryTmpId;
      formData.append("templateId", salaryTmpId);
      Salary.exportSalaryTmp(formData).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "导入成功",
          });
          this.exportCommitTmp(res.result)
          this.loading = false
        } else {
          this.loading = false
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      }).catch(err => {
        this.loading = false
      })
    },

    /* 编辑导入模板 */
    modExportSalaryTmp(formData) {
      this.loading = true
      let payrollId = this.payrollId;
      formData.append("payrollId", payrollId);
      Salary.modExportSalaryTmp(formData).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "导入成功",
          });
          this.exportCommitTmp(res.result)
          this.loading = false
        } else {
          this.loading = false
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      }).catch(err => {
        this.loading = false
      })
    },

    /* 导入模板公共方法 */
    exportCommitTmp(val) {
      let arr = [];
      let userList = [];
      val.map((i, index) => {
        let obj2 = {};
        let uuid = `${new Date().getTime()}${index}`;
        obj2.name = i.userName;
        obj2.id = i.userId;
        obj2.deptId = i.deptId;
        obj2.uuid = uuid;
        let obj = {};
        obj.itemList = [];
        obj.name = i.userName;
        obj.userObj = obj2;
        i.list.map((mapItem) => {
          let obj3 = {};
          obj3.categoryId = mapItem.categoryId;
          obj3.categoryName = mapItem.categoryName;
          obj3.itemName = mapItem.itemName;
          obj3.itemId = mapItem.itemId;
          obj3.contentId = mapItem.contentId;
          obj3.type = mapItem.type;
          obj3.itemValue = handleAmount(mapItem.itemValue, 2);
          if (mapItem.type == "Label")
            obj3.isHight = mapItem.labelMatchFlag == 1 ? true : false;
          if (mapItem.type == "Customize") obj3.isHight = true;
          if (obj.itemList.length == 0) {
            obj.itemList.push({
              uuid: uuid,
              userId: i.userId,
              deptId: i.deptId,
              categoryId: mapItem.categoryId,
              categoryName: mapItem.categoryName,
              List: [obj3],
            });
          } else {
            let res = obj.itemList.some((item) => {
              //判断相同分类id，有就添加到当前项
              if (item.categoryId == mapItem.categoryId) {
                item.List.push(obj3);
                return true;
              }
            });
            if (!res) {
              //如果没找相同分类id添加一个新对象
              obj.itemList.push({
                uuid: uuid,
                userId: i.userId,
                deptId: i.deptId,
                categoryId: mapItem.categoryId,
                categoryName: mapItem.categoryName,
                List: [obj3],
              });
            }
          }
        });
        arr.push(obj);
        userList.push(obj2);
      });
      let newArr = [];
      arr.map((i) => {
        let obj = {};
        i.itemList.map((v) => {
          let key = `${v.categoryName}${v.categoryId}`;
          obj[key] = v.List;
          obj.userObj = i.userObj
          obj.userId = v.userId;
          obj.deptId = v.deptId;
          obj.uuid = v.uuid;
        });
        newArr.push(obj);
      });
      this.categroyTableList = newArr;
      this.tableData = userList;
    },

    /* 多选 */
    handleSelectionChange(v) {
      let arr = [];
      v.map((i) => {
        arr.push(i.uuid);
      });
      this.selectDelStaff = arr;
    },

    /* 删除单个用户 */
    removeUser(index, id) {
      this.tableData.splice(index, 1);
      this.categroyTableList.splice(index, 1);
    },

    /* 批量删除用户 */
    removeAllUser() {
      this.selectDelStaff.map((v) => {
        this.tableData.map((i, index) => {
          if (i.uuid == v) {
            this.tableData.splice(index, 1);
          }
        });

        this.categroyTableList.map((i, idx) => {
          if (i.uuid == v) {
            this.categroyTableList.splice(idx, 1);
          }
        });
      });
    },

    /* 获取分类列表 */
    initSalaryTypeList() {
      let salaryTemplateId = this.salaryTmpId;
      Salary.getSalaryTypeList(salaryTemplateId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.categoryId = i.id;
            obj.categoryName = i.name;
            obj.ruleType = i.ruleType;
            let key = `${i.name}${i.id}`;
            obj.categoryKey = key;
            obj[key] = [];
            obj.itemList = [];
            i.itemList.map((v) => {
              let obj2 = {};
              obj2.categoryId = i.id;
              obj2.categoryName = i.name;
              obj2.itemName = v.name;
              obj2.itemId = v.id;
              obj2.type = v.type;
              if (v.type == "Label") {
                let contentList = [];
                v.contentList.map((t) => {
                  let obj4 = {};
                  obj4.contentId = t.id;
                  obj4.content = t.content;
                  obj4.salaryItemId = t.salaryItemId;
                  obj4.amount = handleAmount(t.amount, 2);
                  contentList.push(obj4);
                });
                obj2.contentList = contentList;
              } else {
                obj2.itemValue =
                  v.contentList.length > 0
                    ? handleAmount(v.contentList[0].amount, 2)
                    : "";

                obj2.contentId = v.contentList.length > 0 ? v.contentList[0].id : "";
                obj2.content =
                  v.contentList.length > 0 ? v.contentList[0].content : "";
              }
              obj.itemList.push(obj2);
              obj[key].push(obj2);
            });
            arr.push(obj);
          });
          this.categroyTitleList = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /*
      以下是批量修改
    */
    /* 关闭抽屉 */
    closeDrawer() {
      this.checkList = []
      this.form.itemName = ''
      this.form.contentId = ''
      this.form.content = ''
      this.form.amount = ''
      this.drawer = false;
    },

    /* 开启批量修改 */
    openBatchModification(v, key) {
      this.drawer = true;
      if (v.type == "Label") this.form.contentList = v.contentList;
      this.form.type = v.type;
      this.form.itemName = v.itemName;
      this.form.itemId = v.itemId;
      this.form.itemValue = v.itemValue;
      this.form.categoryKey = key;
      if (v.type == "Customize") {
        this.form.contentId = v.contentId;
      }
    },

    submitForm() {
      this.checkList.map((v) => {
        this.categroyTableList.map((i) => {
          if (v == i.userId) {
            i[this.form.categoryKey].map((val) => {
              if (val.itemId == this.form.itemId) {
                if (this.form.type == "Customize") {
                  val.itemValue = this.form.content;
                } else {
                  val.itemValue = this.form.amount;
                }
                val.contentId = this.form.contentId
                val.isHight = val.labelMatchFlag == 1 ? true : false;
              }
            });
          }
        });
      });
      this.closeDrawer();
    },

    /* 批量修改处理金额 */
    changeLabel(v) {
      this.form.amount = this.form.contentList.find(
        (ele) => ele.contentId == v
      ).amount;
      this.form.contentId = this.form.contentList.find(
        (ele) => ele.contentId == v
      ).contentId;
    },

    /* 单个修改金额 */
    changeDetails(list, v, row, key, idx) {
      row[key][idx].itemValue = list.find((ele) => ele.contentId == v).amount;
      row[key][idx].contentId = list.find((ele) => ele.contentId == v).contentId;
      row[key][idx].isHight =
        list.find((ele) => ele.contentId == v).amount == null ? false : true;
    },

    /* 单个修改自定义金额 */
    changeLabelDetials(v, row, key, idx, contentId) {
      row[key][idx].isHight = v == null ? false : true;
      row[key][idx].contentId = contentId
    },

    /* 限制自定义金额为两位小数 */
    inputAmount(v, row, key, idx) {
      row[key][idx].itemValue = inputTwoDecimal(v);
    },

    /* 获取选中部门id */
    selectDepartment(v) {
      if (v.level > 2) {
        this.departmentId = v.id;
        if (v.level == 3) this.threeDepetId = v.id
        if (v.level == 4) this.threeDepetId = v.parentId
        this.initMember();
      }
    },

    closeDialog() {
      this.matchIndex = "";
      this.staffList = []
      this.temporaryMatchObj = null;
      this.temporaryAddDetails = [];
      this.temporarySelectPeople = [];
      this.dialogVisible = false;
      this.initDepartmentList()
    },

    /* 多选添加人员 */
    handleSelectionPeople(v) {
      let arr = [];
      let detailsArr = [];
      v.map((i, index) => {
        let obj = {};
        obj.id = i.id;
        let uuid = `${new Date().getTime()}${index}`;
        obj.uuid = uuid;
        obj.deptId = this.threeDepetId;
        obj.name = i.name;
        arr.push(obj);
      });
      this.temporarySelectPeople = arr;

      arr.map((v) => {
        let obj = {};
        this.categroyTitleList.map((i) => {
          obj.userId = v.id;
          obj.deptId = v.deptId;
          obj.uuid = v.uuid;
          obj.userObj = {};
          obj.userObj.id = v.id
          obj.userObj.deptId = v.deptId
          obj.userObj.uuid = v.uuid
          obj.userObj.name = v.name
          obj[i.categoryKey] = [];
          i.itemList.map((mapItem) => {
            let obj3 = {};
            obj3.categoryId = mapItem.categoryId;
            obj3.categoryName = mapItem.categoryName;
            obj3.itemName = mapItem.itemName;
            obj3.itemId = mapItem.itemId;
            obj3.type = mapItem.type;
            if (mapItem.type == "Label") {
              obj3.contentId = '';
              obj3.itemValue = null;
              obj3.isHight = false;
            } else {
              obj3.itemValue = 0;
              obj3.isHight = true;
              obj3.contentId = mapItem.contentId;
            }
            if (obj[i.categoryKey].length == 0) {
              obj[i.categoryKey].push(obj3);
            } else {
              let res = obj[i.categoryKey].some((item) => {
                //判断相同分类id，有就添加到当前项
                if (item.categoryId == mapItem.categoryId) {
                  obj[i.categoryKey].push(obj3);
                  return true;
                }
              });
              if (!res) {
                //如果没找相同分类id添加一个新对象
                obj[i.categoryKey].push(obj3);
              }
            }
          });
        });
        detailsArr.push(obj);
      });
      this.temporaryAddDetails = detailsArr;
    },

    /* 开启匹配 */
    openMatching(index) {
      this.isAddPeople = 2;
      this.matchIndex = index;
      this.dialogVisible = true;
    },

    /* 匹配 */
    matching(row) {
      this.temporaryMatchObj = row;
    },

    confirm() {
      let isFlag = false
      this.tableData.map(i => {
        this.temporarySelectPeople.map(v => {
          if (i.deptId == v.deptId && i.id == v.id ) {
            isFlag = true
          }
        })
      })
      if (isFlag) return this.$message.error('同个用户无法重复添加')

      if (this.isAddPeople == 1) {
        this.tableData = this.tableData.concat(this.temporarySelectPeople);
        this.categroyTableList.push(...this.temporaryAddDetails);
      } else {
        let id = this.temporaryMatchObj.id
        let deptId = this.threeDepetId
        let name = this.temporaryMatchObj.name
        this.tableData[this.matchIndex].id = id;
        this.tableData[this.matchIndex].name = name;
        this.tableData[this.matchIndex].deptId = deptId;
        let row = this.categroyTableList[this.matchIndex]
        row.userId = id
        row.deptId = deptId
        row.userObj.id = id
        row.userObj.name = name
        row.userObj.deptId = deptId
      }
      this.closeDialog();
    },

    addStaff() {
      this.isAddPeople = 1;
      this.dialogVisible = true;
    },

    /* 获取制表人管理范围数据 */
    initDepartmentList() {
      Salary.getTabulator().then((res) => {
        if (res.success) {
          let arr = mapChild(res.result);
          this.companyList = mapId2(arr);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 获取成员 */
    initMember() {
      let id = this.departmentId;
      let query = this.searchStaff;
      Salary.getMember(id, query).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.image = i.image;
            obj.phone = i.phoneNo;
            arr.push(obj);
          });
          this.staffList = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          let templateId
          let payrollId
          if (this.isMod == 1) templateId = this.salaryTmpId;
          if (this.isMod == 2 && this.type == 1) payrollId = this.payrollId;
          if (this.isMod == 2 && this.type == 2) templateId = this.salaryTmpId;
          let month = this.ruleform.month;
          let title = this.ruleform.title;
          let remark = this.ruleform.remark;
          let promptFlag = this.ruleform.promptFlag ? 1 : 0;
          let promptInfo = "工资条属于敏感信息，请注意保密";
          let userEntityList = [];
          let userList = [];
          this.categroyTableList.map((t) => {
            let obj = {};
            obj.userId = t.userId;
            obj.deptId = t.deptId;
            obj.entityList = [];
            this.categroyTitleList.map((i) => {
              t[i.categoryKey].map((v) => {
                let obj2 = {};
                obj2.itemId = v.itemId;
                obj2.itemValue = handleAmount(v.itemValue, 1);
                obj2.categoryId = v.categoryId;
                obj2.contentId = v.contentId;
                if (v.type == "Label")
                  obj2.content = `${v.itemName}${v.itemValue}`;
                if (v.type == "Customize") {
                  i.itemList.map((val) => {
                    if (val.itemId == v.itemId) {
                      obj2.content = val.content;
                    }
                  });
                }
                obj.entityList.push(obj2);
              });
            });
            userList.push(obj);
          });
          userEntityList = userList;
          let data = {
            month,
            title,
            remark,
            promptFlag,
            promptInfo,
            userEntityList,
          };
          if (this.isMod == 1) {
            data.templateId = templateId
          } else {
            if (this.type == 1) data.payrollId = payrollId
            if (this.type == 2) data.templateId = templateId
          }
          Salary.postSavePaySlip(data).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: '保存成功',
              });
              this.salaryFormId = res.result;
              this.loading = false
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
              this.loading = false
            }
          }).catch(err => {
            this.loading = false
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /* 发起审批 */
    launchApproval() {
      let data = {
        id: this.salaryFormId,
      };
      Salary.postInitiateApproval(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "发起审批成功",
          });
          this.$router.push({
            path: "/fire/salaryModuleIndex/salaryFormIndex/salaryForm",
          });
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 以下是编辑时的方法 */
    /* 获取分类列表 */
    initModSalaryTypeList() {
      let payrollId = this.payrollId;
      Salary.getModSalaryTypeList(payrollId).then((res) => {
        if (res.success) {
          this.commonModAndCopySalaryTypeList(res, 1)
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 获取工资条信息 */
    initModSalaryInfo() {
      let payrollId = this.payrollId;
      Salary.getModSalaryInfo(payrollId).then((res) => {
        if (res.success) {
          this.commonModAndCopySalaryInfo(res)
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 编辑和复制时分类列表公共方法 */
    commonModAndCopySalaryTypeList(res, type) {
      let arr = [];
      res.result.map((i) => {
        let obj = {};
        obj.categoryId = i.id;
        obj.payrollId = i.payrollId;
        obj.categoryName = i.name;
        obj.ruleType = i.ruleType;
        let key = `${i.name}${i.id}`;
        obj.categoryKey = key;
        obj[key] = [];
        obj.itemList = [];
        i.itemList.map((v) => {
          let obj2 = {};
          obj2.categoryId = i.id;
          obj2.categoryName = i.name;
          obj2.itemName = v.name;
          obj2.itemId = type == 1 ? v.paySlipItemId: v.id;
          obj2.type = v.type;
          if (v.type == "Label") {
            let contentList = [];
            v.contentList.map((t) => {
              let obj4 = {};
              obj4.contentId = type == 1 ? t.contentId : t.id;
              obj4.content = t.content;
              obj4.salaryItemId = t.salaryItemId;
              obj4.amount = handleAmount(t.amount, 2);
              contentList.push(obj4);
            });
            obj2.contentList = contentList;
          } else {
            obj2.itemValue =
              v.contentList.length > 0
                ? handleAmount(v.contentList[0].amount, 2)
                : "";
            obj2.contentId = v.contentList.length > 0 ? (type == 1 ? v.contentList[0].contentId:v.contentList[0].id) : ""
            obj2.content =
              v.contentList.length > 0 ? v.contentList[0].content : "";
          }
          obj.itemList.push(obj2);
          obj[key].push(obj2);
        });
        arr.push(obj);
      });
      this.categroyTitleList = arr;
    },

    /* 编辑和复制时工资条信息公共方法 */
    commonModAndCopySalaryInfo(res) {
      let arr = [];
      let userList = [];
      res.result.map((i, index) => {
        let obj2 = {};
        let uuid = `${new Date().getTime()}${index}`;
        obj2.name = i.userName;
        obj2.id = i.userId;
        obj2.uuid = uuid;
        obj2.deptId = i.deptId;
        let obj = {};
        obj.name = i.userName;
        obj.userObj = obj2,
        obj.itemList = [];
        i.list.map((mapItem) => {
          let obj3 = {};
          obj3.categoryId = mapItem.categoryId;
          obj3.categoryName = mapItem.categoryName;
          obj3.itemName = mapItem.itemName;
          obj3.itemId = mapItem.itemId;
          obj3.type = mapItem.type;
          obj3.contentId = mapItem.contentId;
          obj3.content = mapItem.content;
          obj3.itemValue = handleAmount(mapItem.itemValue, 2);
          if (mapItem.type == "Label")
            obj3.isHight = mapItem.labelMatchFlag == 1 ? true : false;
          if (mapItem.type == "Customize") obj3.isHight = true;
          if (obj.itemList.length == 0) {
            obj.itemList.push({
              uuid: uuid,
              userId: i.userId,
              deptId: i.deptId,
              categoryId: mapItem.categoryId,
              categoryName: mapItem.categoryName,
              List: [obj3],
            });
          } else {
            let res = obj.itemList.some((item) => {
              //判断相同分类id，有就添加到当前项
              if (item.categoryId == mapItem.categoryId) {
                item.List.push(obj3);
                return true;
              }
            });
            if (!res) {
              //如果没找相同分类id添加一个新对象
              obj.itemList.push({
                uuid: uuid,
                userId: i.userId,
                deptId: i.deptId,
                categoryId: mapItem.categoryId,
                categoryName: mapItem.categoryName,
                List: [obj3],
              });
            }
          }
        });
        arr.push(obj);
        userList.push(obj2);
      });
      let newArr = [];
      arr.map((i) => {
        let obj = {};
        i.itemList.map((v) => {
          let key = `${v.categoryName}${v.categoryId}`;
          obj[key] = v.List;
          obj.userObj = i.userObj;
          obj.userId = v.userId;
          obj.deptId = v.deptId;
          obj.uuid = v.uuid;
        });
        newArr.push(obj);
      });
      this.categroyTableList = newArr;
      this.tableData = userList;
    },

    /* 以下是复制时的方法 */
    /* 获取分类列表 */
    initCopySalaryTypeList() {
      let payrollId = this.payrollId;
      Salary.getCopySalaryTypeList(payrollId).then((res) => {
        if (res.success) {
          this.commonModAndCopySalaryTypeList(res, 2)
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 获取工资条信息 */
    initCopySalaryInfo() {
      let payrollId = this.payrollId;
      Salary.getCopySalaryInfo(payrollId).then((res) => {
        if (res.success) {
          this.commonModAndCopySalaryInfo(res)
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    // 表格是否展示提示
    showTips(obj, row, content) {
      /* obj为鼠标移入时的事件对象 */

      /* currentWidth 为文本在页面中所占的宽度，创建标签，加入到页面，获取currentWidth ,最后在移除 */
      let TemporaryTag = document.createElement("span");
      TemporaryTag.innerText = content;
      /* 去除文本中的html 标签变成纯字符串 */
      TemporaryTag.innerText = TemporaryTag.innerText.replace(/<[^>]+>/g, "");
      TemporaryTag.className = "getTextWidth";
      TemporaryTag.style = "font-size:0.875rem;";
      document.querySelector("body").appendChild(TemporaryTag);
      let currentWidth = document.querySelector(".getTextWidth").offsetWidth;
      document.querySelector(".getTextWidth").remove();

      /*cellWidth为表格容器的宽度*/
      const cellWidth = obj.target.offsetWidth;
      /* 当文本宽度小于||等于容器宽度两倍时，代表文本显示未超过两行 */
        currentWidth <= 1 * cellWidth
          ? (this.isShowTooltip = true)
          : (this.isShowTooltip = false);
    },
  },
};
</script>

<style lang='scss'>
.add-salary-form {
  flex: 1;
  width: 100%;
  background: $bg-white;
  .add-salary-form-container {
    width: 100%;
    height: 100%;
    position: relative;
    @include flex-column-center;
  }
  .title {
    width: 100%;
    height: 56px;
    font-weight: 400;
    text-align: left;
    line-height: 56px;
    padding-left: 20px;
    margin-bottom: 40px;
    box-sizing: border-box;
    font-size: $fs-medium-s;
    color: $color-BlackGrey;
    border-bottom: 1px solid $bg-ShallowLightSnow;
  }
  .add-salary-content {
    width: 100%;
    flex: 1;
    .step-content {
      margin-top: 40px;
      margin-bottom: 80px;
      @include flex-column-center;
      .select-tmp {
        width: 62%;
        height: 284px;
        box-sizing: border-box;
        background: $bg-ChangeDepartmentTree;
        border: 1px solid $bg-Gainsboro;
        border-radius: 8px;
        padding: 29px 38px;
        .select-tmp-title {
          font-size: $fs-medium-s;
          font-weight: bold;
          color: $color-BlackGrey;
          margin-bottom: 61px;
          text-align: left;
        }
        .download {
          cursor: pointer;
          margin-top: 19px;
          font-size: $fs-medium-s;
          font-weight: 400;
          color: $color-DeepReddishBlue;
        }
        .el-select .el-input__suffix {
          top: 0px;
        }
      }
      .explain {
        width: 62%;
        height: 222px;
        background: $bg-white;
        border: 1px solid $bg-DoopLightSnow;
        border-radius: 8px;
        margin-top: 20px;
        text-align: left;
        padding: 24px 29px;
        box-sizing: border-box;
        ul {
          padding-left: 20px;
          li {
            list-style: disc;
            font-size: $fs-medium-s;
            font-weight: 400;
            color: $color-grey;
            margin-top: 21px;
          }
        }
        .explain-title {
          font-size: $fs-medium-s;
          font-weight: bold;
          color: $color-BlackGrey;
        }
      }
    }
    .step2-content {
      margin-top: 40px;
      margin-bottom: 80px;
      padding: 0px 20px;
      box-sizing: border-box;
      .del-select-container {
        @include flex-start;
        .del-select {
          margin-top: 20px;
          width: 120px;
        }
      }
      .salary-table .hidden-columns,
      .salary-table td.is-hidden>*,
      .salary-table th.is-hidden>*,
      .salary-table.el-table--hidden {
        visibility: visible;
      }
      .right {
        flex: 1;
        overflow-x: auto;
        .activeBorder {
          .el-input__inner {
            border-color: $bg-Crimson;
          }
        }
        .activeColor {
          color: $bg-Crimson;
        }
        .table .el-table .el-table__header-wrapper .el-table__header tr th .cell,
        .table .el-table .el-table__fixed-header-wrapper .el-table__header tr th .cell {
          padding-left: 8px;
          padding-right: 8px;
        }
        .table .el-table .el-table__body-wrapper .el-table__body tr td .cell,
        .table .el-table .el-table__fixed-body-wrapper .el-table__body tr td .cell {
          padding: 0px 8px;
        }
      }
      .item-title {
        @include flex-start;
        .item-name {
          flex: 1;
          overflow : hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    .step3-content {
      @include flex-center;
      align-items: flex-start;
      margin-top: 40px;
      margin-bottom: 80px;
      padding: 0px 20px;
      .step3-right {
        width: 302px;
        // min-height: 603px;
        background: url("../../../../assets/phone.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 34px 14px 14px 14px;
        .pay-title {
          @include flex-center;
          height: 34px;
          line-height: 34px;
          text-align: center;
          font-size: $fs-small-l;
          font-weight: bold;
          color: $color-Step;
          position: relative;
          .preview {
            position: absolute;
            right: 0px;
            width: 40px;
            height: 26px;
            line-height: 26px;
            box-sizing: border-box;
            background: linear-gradient(270deg, #fa8100 0%, #ffb362 100%);
            border-radius: 13px 0px 0px 13px;
            font-size: $fs-small-m;
            font-weight: 400;
            color: $bg-white;
          }
          .pay-text {
            width: 220px;
            @include two-wrap-ellipsis(1);
          }
        }
        .pay-info {
          width: 100%;
          height: 100px;
          background: url("../../../../assets/bg-paySlip.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          padding: 15px 0px;
          box-sizing: border-box;
          .pay-slip-name {
            font-size: $fs-small-m;
            font-weight: 400;
            color: $color-white;
          }
          .pay-slip-amount {
            font-size: 30px;
            font-weight: 500;
            color: $color-white;
            margin: 11px 0px;
          }
          .pay-slip-title {
            font-size: $fs-small-m;
            font-weight: 400;
            color: $color-white;
            opacity: 0.65;
          }
        }
        .pay-slip-reminder {
          width: 100%;
          height: 24px;
          line-height: 24px;
          text-align: left;
          padding-left: 30px;
          box-sizing: border-box;
          background: url("../../../../assets/paySlip-title.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          font-size: $fs-small-m;
          font-weight: 400;
          color: $color-BlackGrey;
        }
        .step3-right-content {
          height: 440px;
          overflow: auto;
          @include scrollbarNotrack(0);
          border-radius: 0px 0px 36px 36px;
          padding-bottom: 30px;
          .preview-container {
            background: $bg-ChangeDepartmentTree;
            .category-title {
              padding: 0px 10px;
              height: 32px;
              box-sizing: border-box;
              line-height: 32px;
              text-align: left;
              font-size: $fs-small-m;
              font-weight: 400;
              color: $color-LightGrey;
            }
            .preview-details {
              padding: 0px 10px;
              background: $bg-white;
              box-sizing: border-box;
              border-bottom: 1px solid $bg-ShallowLightSnow;
              @include flex-between;
              font-size: $fs-small-l;
              font-weight: 400;
              color: $color-grey;
              height: 36px;
              .preview-details-name {
                display: flex;
                justify-content: flex-start;
              }
              .tooltip {
                width: 14px;
                height: 14px;
                margin-left: 5px;
              }
            }
          }
        }
      }
      .step3-left {
        width: 688px;
        min-height: 603px;
        box-sizing: border-box;
        background: $bg-ChangeDepartmentTree;
        border-radius: 8px;
        margin-right: 25px;
        padding-top: 48px;
        @include flex-column-center;
        .demo-form {
          .el-form-item {
            @include flex-start;
            .el-form-item__label {
              width: 100px;
            }
          }
          .remark {
            .el-form-item__label {
              height: 100px;
            }
            .el-form-item__content {
              width: 348px;
            }
          }
        }
        .salary-title {
          text-align: left;
          width: 348px;
          height: 114px;
          margin-bottom: 24px;
          background: $bg-white;
          border: 1px solid $bg-DoopLightSnow;
          border-radius: 2px;
          padding: 11px 15px;
          margin-left: 100px;
          box-sizing: border-box;
          font-size: $fs-medium-s;
          font-weight: bold;
          color: $color-grey;
        }
      }
    }
  }
  .foot {
    position: absolute;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    .el-button {
      padding: 0;
    }
    .export-tmp {
      margin-right: 20px;
    }
  }

  .matching-img {
    width: 24px;
    height: 24px;
    margin-right: 6px;
    border-radius: 50%;
  }

  .sub-title {
    text-align: left;
    font-size: $fs-medium-s;
    font-weight: 400;
    margin-bottom: 25px;
    color: $color-Step;
  }
  .el-drawer__wrapper {
    top: 119px !important;
    right: 20px !important;
    .el-form-item {
      margin-bottom: 0px;
    }
  }
  .check-title {
    text-align: left;
    vertical-align: middle;
    font-size: 14px;
    line-height: 40px;
    padding: 0 12px 0 0;
    color: #606266;
    box-sizing: border-box;
  }
  .el-checkbox-group {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .el-checkbox {
      width: 27%;
      height: 36px;
      line-height: 36px;
      padding-left: 10px;
      margin-right: 10px;
      text-align: left;
      background: #f8f9fa;
      margin-bottom: 14px;
    }
  }
  .el-select {
    .el-input__suffix {
      top: -3px;
    }
  }

  .stayDistribution {
    display: flex;
    .table-left {
      width: 370px;
      padding-right: 16px;
      border-right: 1px solid $bg-ShallowLightSnow;
      box-sizing: border-box;
      overflow: hidden;
      .search-table {
        margin-bottom: 16px;
      }
    }
    .table-right {
      flex: 1;
      padding: 0px 16px;
      margin-right: 16px;
      border-right: 1px solid $bg-ShallowLightSnow;
      box-sizing: border-box;
      overflow: hidden;
      .title {
        height: 36px;
        font-weight: 400;
        line-height: 36px;
        border-radius: 2px;
        margin-bottom: 14px;
        text-align: left;
        padding-left: 7px;
        font-size: $fs-small-l;
        color: $color-OriginYellow;
        background: $bg-OriginYellow;
      }
      .tree {
        height: 300px;
        overflow-y: auto;
        @include scrollbarNotrack(0px);
      }
    }
  }
  .el-dialog .el-dialog__header {
    border-bottom: none;
  }
  .el-dialog .el-dialog__footer {
    border-top: none;
  }
}
</style>
